import { File, User } from './Organization'
import { Repository } from './Repository'

export enum AssignStatus {
  NotAssigned = 'NOT_ASSIGNED',
  AssignRequested = 'ASSIGN_REQUESTED',
  Reject = 'REJECT',
  Reassign = 'REASSIGN',
  InProgress = 'IN_PROGRESS',
  Approved = 'APPROVED',
}

export enum AssignDisciplineNames {
  Mechanical = 'MECHANICAL',
  Electrical = 'ELECTRICAL',
  Structural = 'STRUCTURAL',
  Plumbing = 'PLUMBING',
}

export interface AssignItem {
  discipline: AssignDisciplineNames
  discipline_status: AssignStatus
  status?: AssignStatus
  user?: User
  organization_id: number
  file_id?: number
  user_id?: number | null
}

export interface AssignProject extends Repository {
  file: File
  status: AssignStatus
  organization_id: number
  file_id: number
  disciplines: AssignDiscipline[]
}

export interface AssignDiscipline extends Repository {
  discipline_status: AssignStatus
  discipline: AssignDisciplineNames
  organization_file_id: number
  user_id: number
  file_id: number
  user?: User
}
